module.exports = "label.search-filter {\n    font-size: 1.5rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/list/list.component.css
// module id = ./src/app/articles/list/list.component.css
// module chunks = main